<template>
  <l-autocomplete
    v-model="localModel"
    label="Race/ethnicity"
    help="You may select one or more race or ethnicity."
    placeholder="Search"
    name="race[]"
    :items="races"
    item-key="value"
    multiple
  />
</template>

<script setup>
import LAutocomplete from "@/components/inputs/LAutocomplete.vue"
import { find, map } from "lodash-es"
import { ref, watch } from "vue"
import { useRaces } from "@/composables/useRaces"

const model = defineModel({ type: Array, default: () => [] })

const emit = defineEmits(["input"])

const { races } = useRaces()

const localModel = ref(model.value.map(value => find(races, { value })))

watch(localModel, value => {
  model.value = map(value, "value")

  emit("input", model.value)
})
</script>
